<script>
import { styleState } from "@app/store/styleStore.svelte.js";
import { projectState } from "@app/store/projectStore.svelte.js";
import { eventGroupState, isSelectedEventGroupLocked } from "@app/store/eventGroupStore.svelte.js";
import { insertHistoryAction } from "@app/store/historyStore.svelte.js";
import {
    normalizeEventYPosition,
    resolveEventYPosition,
} from "@app/lib/eventPosition.js";
import { toast } from "@zerodevx/svelte-toast";
import * as m from '@app/paraglide/messages.js';

let isDisabled = $derived(!eventGroupState[projectState.selected] ||
    eventGroupState[projectState.selected].selected.length === 0 ||
    isSelectedEventGroupLocked());

function moveDownOneLine() {
    if (isSelectedEventGroupLocked()) {
        toast.push(m.event_group_locked_toast(), { classes: ["toast-warning"] });
        return;
    }

    // Get current event group's display dimensions
    const displayHeight = styleState.height || 15;

    eventGroupState[projectState.selected].selected.forEach((evIndex) => {
        try {
            const event = eventGroupState[projectState.selected].events[evIndex];
            const currentY = resolveEventYPosition(event, displayHeight);
            event.yPos = normalizeEventYPosition(event, currentY + 1, displayHeight);
        } catch (err) {
            console.error("Position line down error");
            console.error(err.message);
            console.log(err);
        }
    });

    insertHistoryAction({
        name: "position line down", //action name
        eventGroup: projectState.selected,
        snapshots: [
            {
                store: "eventGroupState",
                value: JSON.stringify(eventGroupState),
            },
        ],
    });
}
</script>

<li class="nav-item" title={m.position_line_down_title()}>
    <a
        class="nav-link"
        href="#!/"
        role="button"
        id="position-line-down-btn"
        aria-label={m.position_line_down_aria_label()}
        class:disabled={isDisabled}
        aria-disabled={isDisabled}
        onclick={moveDownOneLine}>
        <i class="bi bi-chevron-down" aria-hidden="true"></i>
    </a>
</li>
